import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useT } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export default function Availability() {
  const { t } = useT();
  const { user } = useAuth();
  const [av, setAv] = useState({});

  useEffect(() => {
    api.get(`/schedule/availability/${user.id}`).then((r) => {
      const base = {};
      DAYS.forEach((d) => { base[d] = r.data.availability?.[d] || { available: false, from: "08:00", to: "16:00" }; });
      setAv(base);
    });
  }, [user.id]);

  const set = (day, k, v) => setAv((a) => ({ ...a, [day]: { ...a[day], [k]: v } }));
  const save = async () => { await api.put("/schedule/availability", { availability: av }); toast.success(t("availabilitySaved")); };

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-display text-3xl font-bold tracking-tight">{t("availability")}</h1>
        <Button onClick={save} data-testid="save-availability">{t("save")}</Button>
      </div>
      <Card className="divide-y divide-border">
        {DAYS.map((day) => (
          <div key={day} className="flex items-center gap-4 p-4" data-testid="availability-row">
            <label className="flex items-center gap-2 w-40 shrink-0 cursor-pointer">
              <input type="checkbox" checked={av[day]?.available || false} onChange={(e) => set(day, "available", e.target.checked)} className="w-4 h-4" data-testid={`av-${day}`} />
              <span className="font-medium">{t(day)}</span>
            </label>
            {av[day]?.available ? (
              <div className="flex items-center gap-2 flex-1">
                <span className="text-sm text-muted-foreground">{t("from")}</span>
                <Input type="time" value={av[day].from} onChange={(e) => set(day, "from", e.target.value)} className="w-32" />
                <span className="text-sm text-muted-foreground">{t("to")}</span>
                <Input type="time" value={av[day].to} onChange={(e) => set(day, "to", e.target.value)} className="w-32" />
              </div>
            ) : <span className="text-sm text-muted-foreground">{t("inactive")}</span>}
          </div>
        ))}
      </Card>
    </div>
  );
}
